import './Auth.scss';
import { ReactElement } from 'react';
import { LockedContainer } from '../../modules/locked/Locked.container';

export const LockedView = (): ReactElement => <LockedContainer />;
